import { Head } from '@inertiajs/react'
import { DealsTable } from "@/components/deals-table"

export default function Archived() {
  return (
    <>
      <Head title="Archived Deals" />
      <DealsTable title="Archived Deals" subtitle="No longer active" />
    </>
  )
}
